import TableFilter from './tableFilter'
import ExportButton from '../../common/ExportButton'
import { contributionExportColumns } from '../../config/exportColumns/contributionExportColumns'
import { appAllGetContribution } from '../../store/contribution'
import { useState } from 'react'
import { useDispatch } from 'react-redux'

function Contribution() {
	const dispatch = useDispatch()
	const [exportFilters, setExportFilters] = useState({})

	const sansthaId = localStorage.getItem('sansthaId')
	const permissionOfSanstha = localStorage.getItem('permissionOfSanstha')

	return (
		<>
			<div className="content-wrapper">
				<div
					className="content-heading d-flex
                          justify-content-between"
				>
					<div>Contribution</div>
					<div>
						<ExportButton
							fetchAction={params =>
								dispatch(
									appAllGetContribution({
										...params,
										...exportFilters,
										sanstha: sansthaId || permissionOfSanstha,
										limit: 10000,
										loading: false,
									}),
								)
							}
							columns={contributionExportColumns}
							fileName="Contributions"
							sheetName="Contribution List"
							buttonText="Export Contributions"
						/>
					</div>
				</div>
				<TableFilter setExportFilters={setExportFilters} />
			</div>
		</>
	)
}

export default Contribution
